<!-- TODO US482401: Add a header section to display solution group name and close button only if modal is launched from right section -->

<!-- Neptune design -->
<ng-container *ngIf="isRefreshedSolutionParticipationUIEnabled; else legacyProductDetailsTable">
    <table class="sp-product-details-table w-full table-fixed border-collapse text-xs text-neptune-color-fg-muted">
        <thead>
            <tr class="text-left text-neptune-default">
                <td class="w-[40%] p-1 sp-loc-product-product-name-header">Product Name</td>
                <td class="w-[12%] p-1 sp-loc-product-last-purchase-header">Last Purchased</td>
                @if (!hideRebateMplSplColumns) {
                <td class="w-[12%] p-1 sp-loc-product-rebate-header">Rebate</td>
                <td class="w-[12%] p-1 sp-loc-product-mpl-header">MPL</td>
                <td class="w-[12%] p-1 sp-loc-product-spl-header">SPL</td>
                }
                <td class="w-[12%] p-1 sp-loc-product-distributor-product-header">Distributor Product</td>
            </tr>
        </thead>
        <tbody>
            @for (product of sortedProductData; track product.productCode) {
            <tr class="text-left text-neptune-default product-details-row">
                <td class="p-1 text-left sp-loc-product-product-name">{{product.productName}} ,<br>SKU - {{product.productCode}}</td>
                <td class="p-1 text-left sp-loc-product-last-purchase">{{product.lastPurchased}}</td>
                @if (!hideRebateMplSplColumns) {
                <td class="p-1 text-left sp-loc-product-rebate">
                    @switch (product.rebate) {
                        @case ('3') { <img src="assets/solution-participation/check-icon.svg" alt="Green Checkmark Icon" class="w-4"> }
                        @case ('2') { <img src="assets/solution-participation/warning-icon.svg" alt="Yellow Warning Icon" class="w-4"> }
                        @case ('1') { <img src="assets/solution-participation/close-icon.svg" alt="Red Cross Icon" class="w-4"> }
                    }
                </td>
                <td class="p-1 text-left sp-loc-product-mpl">
                    @switch (product.mpl) {
                        @case ('3') { <img src="assets/solution-participation/check-icon.svg" alt="Green Checkmark Icon" class="w-4"> }
                        @case ('2') { <img src="assets/solution-participation/warning-icon.svg" alt="Yellow Warning Icon" class="w-4"> }
                        @case ('1') { <img src="assets/solution-participation/close-icon.svg" alt="Red Cross Icon" class="w-4"> }
                    }
                </td>
                <td class="p-1 text-left sp-loc-product-spl">
                    @switch (product.spl) {
                        @case ('3') { <img src="assets/solution-participation/check-icon.svg" alt="Green Checkmark Icon" class="w-4"> }
                        @case ('2') { <img src="assets/solution-participation/warning-icon.svg" alt="Yellow Warning Icon" class="w-4"> }
                        @case ('1') { <img src="assets/solution-participation/close-icon.svg" alt="Red Cross Icon" class="w-4"> }
                    }
                </td>
                }
                <td class="p-1 text-left sp-loc-product-distributor-status">{{product.distributorProduct}}</td>
            </tr>
            }
        </tbody>
    </table>
</ng-container>

<!-- Legacy design -->
<ng-template #legacyProductDetailsTable>
<table class="product-details-table">
    <thead>
        <tr>
            <td>Product Name</td>
            <td>Last Purchased</td>
            <td *ngIf="!hideRebateMplSplColumns">Rebate</td>
            <td *ngIf="!hideRebateMplSplColumns">MPL</td>
            <td *ngIf="!hideRebateMplSplColumns">SPL</td>
            <td>Distributor Product</td>
        </tr>
    </thead>
    <tbody>
        <tr *ngFor="let product of sortedProductData" class="product-details-row">
            <td class="product-name-sku">{{product.productName}} ,<br>SKU - {{product.productCode}}</td>
            <td class="product-last-purchased">{{product.lastPurchased}}</td>
            <td class="product-rebate-status" *ngIf="!hideRebateMplSplColumns">
                <ng-container [ngSwitch]="product.rebate">
                    <img *ngSwitchCase="'3'" src="assets/solution-participation/check-icon.svg" alt="Green Checkmark Icon" class="status-icon green-icon">
                    <img *ngSwitchCase="'2'" src="assets/solution-participation/warning-icon.svg" alt="Yellow Warning Icon" class="status-icon yellow-icon">
                    <img *ngSwitchCase="'1'" src="assets/solution-participation/close-icon.svg" alt="Red Cross Icon" class="status-icon red-icon">
                </ng-container>
            </td>
            <td class="product-mpl-status" *ngIf="!hideRebateMplSplColumns">
                <ng-container [ngSwitch]="product.mpl">
                    <img *ngSwitchCase="'3'" src="assets/solution-participation/check-icon.svg" alt="Green Checkmark Icon" class="status-icon green-icon">
                    <img *ngSwitchCase="'2'" src="assets/solution-participation/warning-icon.svg" alt="Yellow Warning Icon" class="status-icon yellow-icon">
                    <img *ngSwitchCase="'1'" src="assets/solution-participation/close-icon.svg" alt="Red Cross Icon" class="status-icon red-icon">
                </ng-container>
            </td>
            <td class="product-spl-status" *ngIf="!hideRebateMplSplColumns">
                <ng-container [ngSwitch]="product.spl">
                    <img *ngSwitchCase="'3'" src="assets/solution-participation/check-icon.svg" alt="Green Checkmark Icon" class="status-icon green-icon">
                    <img *ngSwitchCase="'2'" src="assets/solution-participation/warning-icon.svg" alt="Yellow Warning Icon" class="status-icon yellow-icon">
                    <img *ngSwitchCase="'1'" src="assets/solution-participation/close-icon.svg" alt="Red Cross Icon" class="status-icon red-icon">
                </ng-container>
            </td>
            <td class="product-distributor-status">{{product.distributorProduct}}</td>
        </tr>
    </tbody>
</table>
</ng-template>
